<script>
    import { Collection } from "sveltefire";
    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();

    import HeaderIntro from "../components/basic/HeaderIntro.svelte";
    import OrderFrameContainer from "../components/dashboard/OrderFrameContainer.svelte";

    export let userdata;
    export let userRef;
    export let orderFrames;
</script>

<div class="animate__fadeIn animate__animated">
  <Collection
    path={userRef.collection("orders")}
    query={(ref) => ref.orderBy("createdAt")}
    let:data={orders}
    let:ref={ordersRef}
    log
  >

    <HeaderIntro mainText={`Hallo ${userdata.firstName}!`} subText={"Du kannst hier deine bereits getätigten Bestellungen einsehen oder neue Bestellungen aufgeben."}/>
    <OrderFrameContainer {orders} {orderFrames}/>

  </Collection>
</div>